import RestoreIcon from '@mui/icons-material/Restore';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityType, Hcphco } from '@/core/graphql/generated/types';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';
import { useBreakpoint } from '@/utils/useBreakpoint';

import { ProfileStatusDcrControl } from '../ProfileStatusDcrControl/ProfileStatusDcrControl';

import { profileReactivateControlStyles as sx } from './ProfileReactivateControl.styles';

type Props = {
	profile: Hcphco | null;
	entityType: EntityType;
};

export const ProfileReactivateControl = ({ profile, entityType }: Props) => {
	const { t } = useTranslation();
	const isCollapsed = useBreakpoint('sm', 'down');
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);
	const [open, setOpen] = useState(false);

	const onOpen = () => setOpen(true);
	const onClose = () => setOpen(false);

	if (!dcrEnabled) {
		return null;
	}

	return (
		<>
			{!isCollapsed ? (
				<Button
					variant='contained'
					sx={sx.button}
					aria-label={t('Reactivate Profile')}
					onClick={onOpen}
					startIcon={<RestoreIcon />}
				>
					{t('Reactivate Profile')}
				</Button>
			) : (
				<IconButton
					sx={sx.button}
					aria-label={t('Reactivate Profile')}
					onClick={onOpen}
					color='primary'
				>
					<RestoreIcon fontSize='inherit' />
				</IconButton>
			)}

			<ProfileStatusDcrControl
				profile={profile}
				entityType={entityType}
				targetStatus='act'
				open={open}
				onClose={onClose}
			/>
		</>
	);
};
